import { render } from "./comunicaciones_form_generali_auxiliar.vue?vue&type=template&id=09fd15b6"
import script from "./comunicaciones_form_generali_auxiliar.vue?vue&type=script&lang=js"
export * from "./comunicaciones_form_generali_auxiliar.vue?vue&type=script&lang=js"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__